(function () {
  'use strict';

  if (window.AxiomSocialGrid) {
    window.AxiomSocialGrid.initAll(document);
    return;
  }

  var REDUCED_MOTION = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  var MOSAIC_FADE_MS = 500;

  function playVideo(video) {
    if (!video) return;
    var collapsed = video.closest('.social-grid.is-collapsed');
    if (collapsed && video.closest('.social-grid__item--mobile-hidden')) return;
    var mosaic = video.closest('.social-grid--mobile-mosaic');
    if (mosaic && window.matchMedia('(max-width: 767px)').matches && !video.closest('[data-social-grid-mosaic-slot]')) return;
    if (REDUCED_MOTION && REDUCED_MOTION.matches) return;
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(function () {});
  }

  function pauseVideo(video) {
    if (!video) return;
    video.pause();
  }

  function bindVideos(root) {
    var videos = root.querySelectorAll('.social-grid__video');
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      videos.forEach(playVideo);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) playVideo(entry.target);
          else pauseVideo(entry.target);
        });
      },
      { threshold: 0.25 }
    );

    videos.forEach(function (video) {
      observer.observe(video);
    });
    root._socialGridVideoObserver = observer;
  }

  function bindShowMore(root) {
    var button = root.querySelector('[data-social-grid-more]');
    if (!button) return;

    button.addEventListener('click', function () {
      root.classList.remove('is-collapsed');
      button.hidden = true;
      root.querySelectorAll('.social-grid__video').forEach(playVideo);
    });
  }

  function bindMosaic(root) {
    if (!root.classList.contains('social-grid--mobile-mosaic')) return;

    var items = Array.from(root.querySelectorAll('[data-social-grid-item]'));
    var mobileShow = Number(root.dataset.socialGridMobileShow);
    var pool = mobileShow > 0 ? items.slice(0, mobileShow) : items;
    if (pool.length <= 3) return;

    var mobile = window.matchMedia('(max-width: 767px)');
    var visible = false;
    var dwellTimer;
    var phaseTimers = [];
    var destroyed = false;
    var lastSlot = -1;
    var queue = pool.slice(3);
    var observer;
    var editorSwap;

    function canRotate() {
      return !destroyed && !(window.Shopify && window.Shopify.designMode) && mobile.matches &&
        !(REDUCED_MOTION && REDUCED_MOTION.matches) && !document.hidden && visible &&
        !root.contains(document.activeElement);
    }

    function schedule() {
      clearTimeout(dwellTimer);
      if (queue.length && canRotate()) primeImage(queue[0]);
      if (canRotate()) dwellTimer = setTimeout(rotate, 3200);
    }

    function primeImage(item) {
      var image = item.querySelector('img');
      if (!image) return;
      image.loading = 'eager';
      if (image.decode) image.decode().catch(function () {});
    }

    function playItem(item) {
      item.querySelectorAll('.social-grid__video').forEach(playVideo);
    }

    function pauseItem(item) {
      item.querySelectorAll('.social-grid__video').forEach(pauseVideo);
    }

    function rotate() {
      if (!canRotate()) return;
      var slots = Array.from(root.querySelectorAll('[data-social-grid-mosaic-slot]'));
      var options = queue.length === 1 ? [2] : [0, 1, 2].filter(function (slot) { return slot !== lastSlot; });
      var slot = options[Math.floor(Math.random() * options.length)];
      var outgoing = slots.find(function (item) { return Number(item.dataset.socialGridMosaicSlot) === slot + 1; });
      var incoming = queue.shift();
      if (!outgoing || !incoming) return;
      lastSlot = slot;

      primeImage(incoming);

      outgoing.setAttribute('data-social-grid-mosaic-fading', '');
      phaseTimers.push(setTimeout(function () {
        if (root.contains(document.activeElement)) {
          outgoing.removeAttribute('data-social-grid-mosaic-fading');
          queue.unshift(incoming);
          phaseTimers.length = 0;
          schedule();
          return;
        }
        pauseItem(outgoing);
        outgoing.removeAttribute('data-social-grid-mosaic-slot');
        outgoing.removeAttribute('data-social-grid-mosaic-fading');
        // Keep the slot fully empty briefly between the two opacity transitions.
        phaseTimers.push(setTimeout(function () {
          incoming.setAttribute('data-social-grid-mosaic-entering', '');
          incoming.setAttribute('data-social-grid-mosaic-slot', String(slot + 1));
          void incoming.offsetWidth;
          incoming.setAttribute('data-social-grid-mosaic-entering', 'visible');
          playItem(incoming);
          phaseTimers.push(setTimeout(function () {
            incoming.removeAttribute('data-social-grid-mosaic-entering');
            queue.push(outgoing);
            phaseTimers.length = 0;
            schedule();
          }, MOSAIC_FADE_MS));
        }, 220));
      }, MOSAIC_FADE_MS));
    }

    function onVisibilityChange() { schedule(); }
    function onFocusOut() { setTimeout(schedule, 0); }
    document.addEventListener('visibilitychange', onVisibilityChange);
    root.addEventListener('focusin', onVisibilityChange);
    root.addEventListener('focusout', onFocusOut);
    mobile.addEventListener('change', onVisibilityChange);
    if (REDUCED_MOTION) REDUCED_MOTION.addEventListener('change', onVisibilityChange);

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        schedule();
      }, { threshold: 0.1 });
      observer.observe(root);
    } else {
      visible = true;
      schedule();
    }

    root._socialGridMosaicCleanup = function () {
      destroyed = true;
      clearTimeout(dwellTimer);
      phaseTimers.forEach(clearTimeout);
      if (observer) observer.disconnect();
      document.removeEventListener('visibilitychange', onVisibilityChange);
      root.removeEventListener('focusin', onVisibilityChange);
      root.removeEventListener('focusout', onFocusOut);
      mobile.removeEventListener('change', onVisibilityChange);
      if (REDUCED_MOTION) REDUCED_MOTION.removeEventListener('change', onVisibilityChange);
    };

    root._socialGridMosaicReveal = function (item) {
      if (editorSwap) {
        editorSwap.item.removeAttribute('data-social-grid-mosaic-slot');
        editorSwap.displaced.setAttribute('data-social-grid-mosaic-slot', '3');
        editorSwap = null;
      }
      if (!item || item.hasAttribute('data-social-grid-mosaic-slot')) return;
      var displaced = root.querySelector('[data-social-grid-mosaic-slot="3"]');
      if (!displaced) return;
      displaced.removeAttribute('data-social-grid-mosaic-slot');
      item.setAttribute('data-social-grid-mosaic-slot', '3');
      editorSwap = { item: item, displaced: displaced };
    };
  }

  function initRoot(root) {
    if (!root || root.dataset.socialGridReady === 'true') return;
    root.dataset.socialGridReady = 'true';
    bindShowMore(root);
    bindVideos(root);
    bindMosaic(root);
  }

  function initAll(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    context.querySelectorAll('[data-social-grid]').forEach(initRoot);
  }

  window.AxiomSocialGrid = { initAll: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-social-grid]').forEach(function (root) {
      if (root._socialGridVideoObserver) root._socialGridVideoObserver.disconnect();
      if (root._socialGridMosaicCleanup) root._socialGridMosaicCleanup();
      delete root.dataset.socialGridReady;
    });
  });

  document.addEventListener('shopify:block:select', function (event) {
    var item = event.target.closest('[data-social-grid-item]');
    var root = event.target.closest('[data-social-grid]');
    if (item && root && root._socialGridMosaicReveal) root._socialGridMosaicReveal(item);
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    var root = event.target.closest('[data-social-grid]');
    if (root && root._socialGridMosaicReveal) root._socialGridMosaicReveal(null);
  });
})();
